import React, { useEffect, useState } from "react";
import "../styles/Values.css";

import icon1 from "../assets/clients/icon1.jpg";
import icon2 from "../assets/clients/icon2.jpeg";
import icon3 from "../assets/clients/icon3.png";
import icon4 from "../assets/clients/icon4.png";
import icon5 from "../assets/clients/icon5.jpg";
import icon9 from "../assets/clients/icon9.png";
import icons7 from "../assets/clients/icons7.png";
import icons10 from "../assets/clients/icons10.png";
import icons11 from "../assets/clients/icons11.png";
import icons12 from "../assets/clients/icons12.png";
import icons13 from "../assets/clients/icons13.png";
import icons14 from "../assets/clients/icons14.png";
const stats = [
  { icon: "fas fa-gem", count: 550, suffix: "+", label: "Types of Marble" },
  { icon: "fas fa-smile", count: 85000, suffix: "+", label: "Happy Clients" },
  { icon: "fas fa-award", count: 55, suffix: "+", label: "Years Experience" },
  { icon: "fas fa-globe", count: 50, suffix: "+", label: "Countries" },
  { icon: "fas fa-building", count: 350, suffix: "+", label: "Brands" },
  { icon: "fas fa-palette", count: 1000, suffix: "+", label: "Exotic Colours" },
  { icon: "fas fa-layer-group", count: 250, suffix: "+", label: "White Varieties" },

];

// Replace these image URLs with your actual logos
const clients = [
  { name: "JW Marriott", img: icon1 },
  { name: "Taj", img: icon2 },
  { name: "Fortis", img: icon3 },
  { name: "Buena Vista International", img: icon4 },
  { name: "Swami Narayan", img: icon5 },
  { name: "The Raymond", img: icon9 },
  { name: "The Jaypee Hotels", img: icons7 },
  { name: "The Raj Palace", img: icons10 },
  { name: "ITC Rajputana Jaipur", img: icons11 },
  { name: "Larsen & Toubro", img: icons12 },
  { name: "Royale Estate Group", img: icons13 },
  { name: "ZZ Architects", img: icons14 },
];


const Values = () => {
  const [counters, setCounters] = useState(stats.map(() => 0));

  // Counter animation
  useEffect(() => {
    const interval = setInterval(() => {
      setCounters((prev) =>
        prev.map((val, i) =>
          val < stats[i].count ? val + Math.ceil(stats[i].count / 50) : stats[i].count
        )
      );
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <section id="values" className="values-section">
      <h2 className="section-title">A Legacy of Quality: India’s Most Trusted Marble Brand</h2>

      <div className="values-grid">
        {stats.map((stat, index) => (
          <div className="value-card" key={index}>
            <div className="value-icon">
              <i className={stat.icon}></i>
            </div>
            <div className="counter">
              {counters[index]}
              {stat.suffix}
            </div>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>

      <div className="clients-strip">
        <h3 className="trusted-title">Trusted By Leading Brands</h3>
        <div className="clients-track">
          {/* duplicate for seamless infinite scroll */}
          {[...clients, ...clients].map((client, index) => (
            <div className="client-logo" key={index}>
              <img src={client.img} alt={client.name} title={client.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
